import { render, staticRenderFns } from "./labelSettings.vue?vue&type=template&id=256ddfbc&scoped=true&"
import script from "./labelSettings.vue?vue&type=script&lang=js&"
export * from "./labelSettings.vue?vue&type=script&lang=js&"
import style0 from "./labelSettings.vue?vue&type=style&index=0&id=256ddfbc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ddfbc",
  null
  
)

export default component.exports